<template>
<div id='driving-cycle-table'>  
<b-row>
   
<b-col>
  <b-table
    striped
    :items="items" 
    :fields="fields"
    id='bs-table'
    :per-page="perPage"
    :current-page="this.currentPage"
    >
    <template v-slot:cell(status)="data">
        <b-icon v-if="data.item.vehicleId" icon="check" scale="2.5" variant="success"></b-icon>
        <b-icon v-else icon="exclamation" scale="2.5" variant="danger"></b-icon>
        <b-icon v-if="newItem && newItem.id == data.item.id" icon="calendar-plus" scale="1.5" variant="warning" class="ml-3" animation="fade"></b-icon>
    </template>
    <template  v-slot:cell(times)="data">
        <div class="one-line-text">{{ formatTime(data.item.startTime) }} - {{ formatTime(data.item.endTime) }}</div>
        
    </template>
    <template v-slot:cell(vehicle)="data">
        <div :class='{ changed: vehicleChanged(data.item) }'>
        <vSelect 
            :options="getVehicleOptions(data.item)" 
            :reduce="option => option.id" 
            :clearable="false"
            :disabled="loading" 
            v-model="data.item.vehicleId"
            @input="vehicleUpdated(data.item)"    
            />
        </div>
   </template>
    <template v-slot:cell(departures)="data">
        <div :key="updateView" v-if="!departuresVisible.has(data.item.id)"><b-icon role="button" icon="list-ul" scale="1.5" @click="showDepartures(data.item.id)"></b-icon></div>
        <div v-else>
            <b-icon v-if="loadingDepartures == data.item.id" icon="arrow-clockwise" animation="spin" scale="1.5"></b-icon>
            <div v-else>
                <div><b-icon role="button" icon="x" scale="1.5" @click="hideDepartures(data.item)"></b-icon></div>

                <div v-if="splitApplied.has(data.item.id)">
                    <table class="departure-table" :key="updateView">
                        <tr v-for="dep in getDepartures(data.item.id).slice(0, splitApplied.get(data.item.id))" :key="dep.lahtoaika"> 
                            <td class='line'>{{ getLineLabel(dep.linja) }}</td>
                            <td>{{ getDestination(dep.reitti) }}</td>
                            <td v-if="$UiConfig('/data/departure/showCourse', false)">{{ dep.tripShortName }}</td>
                            <td>{{ formatTime(dep.lahtoaika) }} - {{ formatTime(dep.ohitusaika) }}</td>
                        </tr>
                    </table>
                    
                    <div class='splitter'>
                      <b-button class="btn-success btn-report" @click="saveSplit(data.item)" :disabled="loading">
                        <b-icon icon="plus-circle" scale="1.5"></b-icon>
                        {{ $t('drivingCycle.create') }}
                    </b-button>
                    </div>
                   <table class="departure-table" :key="updateView">
                        <tr v-for="dep in getDepartures(data.item.id).slice(splitApplied.get(data.item.id))" :key="dep.lahtoaika"> 
                            <td class='line'>{{ getLineLabel(dep.linja) }}</td>
                            <td>{{ getDestination(dep.reitti) }}</td>
                            <td v-if="$UiConfig('/data/departure/showCourse', false)">{{ dep.tripShortName }}</td>
                            <td>{{ formatTime(dep.lahtoaika) }} - {{ formatTime(dep.ohitusaika) }}</td>
                        </tr>
                    </table>
                </div>
                <div v-else>
                    <table class="departure-table" :key="updateView">
                    <tr v-for="(dep, index) in getDepartures(data.item.id)" :key="dep.lahtoaika"> 
                        <td><b-icon v-if="index > 0" role="button" icon="arrows-expand" scale="2" variant='danger' @click="split(data.item, dep, index)" :title="$t('drivingCycle.split')" ></b-icon></td>
                        <td class='line'>{{ getLineLabel(dep.linja) }}</td>
                        <td>{{ getDestination(dep.reitti) }}</td>
                        <td v-if="$UiConfig('/data/departure/showCourse', false)">{{ dep.tripShortName }}</td>
                        <td>{{ formatTime(dep.lahtoaika) }} - {{ formatTime(dep.ohitusaika) }}</td>
                    </tr>
                    </table>
                </div>

            </div>
        </div>
          
    </template>
   
</b-table>

<TablePagination :perPage="perPage" :totalRows="rows" @pageChange=onPageChange></TablePagination>

</b-col>
</b-row>

</div>    
</template>

<script>
import vSelect from 'vue-select'

import realtime from '@/store/realtime/realtime'
import timetable from '@/store/timetable/timetable'
import timeUtils from '@/util/timeUtils'

const VehicleAssignedEnum = Object.freeze({
    ALL: 0,
    VEHICLE: 1,
    NO_VEHICLE: 2
});

export default {
    VehicleAssignedEnum,
    name: 'drivingCycleListTable',
    components: { vSelect },
  
    props: {
        item: { required: true },
        filter: { default: { block: null, vehicle: null } }
    },    
    data: function() {
        return {
            fields: [
                { key: "status" , label: "", tdClass: 'status' },
                { key: "blockLabel" , label: this.$t('drivingCycle.block') },
                { key: "times" , label: this.$t('drivingCycle.times') },
                { key: "vehicle" , label: this.$t('drivingCycle.vehicle'),  tdClass: 'vehicle' },
                { key: "departures" , label: this.$t('departure.departures'), thClass: 'departures', tdClass: 'departures' }
            ],
            /*
			filter: {
				block: null,
				vehicle: null
            },
            */

            departures: [],
            vehicleList: [],
            ok: false,
            error: false,
            loading: false,
            infoType: "save",
            dateList: [],
            changes: new Map(),
            saveButtonDisabled: true,
            departureMap: new Map(),
            updateView: 0,
            loadingDepartures: null,
            splitApplied: new Map(),
            departuresVisible: new Set(),
            newItem: null,
            vehicleOptions: [],
            perPage: 50,
            currentPage: 1
        }
    },
    computed: {
        items(){
            var list = [];

            for (var data of this.$store.state.realtime.drivingCycles.list){
                for (var bs of data.blockSequences) {
                    if(this.getDate(bs.startTime) == this.item && this.filterItem(bs))
                        list.push(bs);
                }
            }
            return list;
        },

      
        bsList() {
            var allBlockSequences = this.$store.state.realtime.drivingCycles.list;
            var bsListOfOrganisation = [];

            for (var bs of allBlockSequences) {
                var bsListOfDay = [];

                for (var b of bs.blockSequences) {
                    if (this.getDate(b.startTime) == this.item && this.filterItem(b)) {
                        bsListOfDay.push(b);
                    }
                }
                bsListOfOrganisation.push({organisationName: bs.organisationName, blockSequences: bsListOfDay});
            }
            return bsListOfOrganisation;
        },
      
        vehicles() {
            return this.$store.state.realtime.vehicles.list;
        },
        routes(){
            return this.$store.state.timetable.routes.list;
        },
        lines() {
            return this.$store.state.timetable.lines.list;
        },
        rows() {
            return this.items.length
        }
       
    },
    created() {
        if (!this.$store.state.realtime) {
            this.$store.registerModule("realtime" , realtime);
        }
        this.$store.dispatch('realtime/getVehicleList');       

        if (!this.$store.state.timetable) {
            this.$store.registerModule("timetable" , timetable);
        }
        this.$store.dispatch('timetable/getRoutesWithDestinations');
        this.$store.dispatch('timetable/getLinesListData');
    },
    methods: {
        vehicleChanged(item){
            var list = Array.from(this.changes.values());
            var found = list.find( c => c.id == item.id);
            return found != null;
        },

        getLineLabel(lineId){
            let label = "-"
            if(lineId){
                const line = this.lines.find(l => l.tunnus == lineId);
                if(line) label = line.tunnusteksti;
            }
            return label;
        },

        getDestination(routeId){
            let destination = "-";
            if(routeId){
                const route = this.routes.find(r => r.tunnus == routeId);
                if(route && route.destinations[0]){
                    destination = route.destinations[0].nimi;
                }
            }

            return destination;
        },

        getVehicleLabel(vehicleId){
            let label = "-"
            if(vehicleId){
                const vehicle = this.vehicles.find(v => v.vehicleId == vehicleId);
                if(vehicle) label = vehicle.vehicleLabel;
            }
            return label;
         },

        getVehicle(item){
            return item.vehicleLabel ? item.vehicleLabel : "-";
        },
        getVehicleOptions(blockSequence){
            var options = [];
            options.push( { id: null, label: '-', blockSequence: blockSequence.id } );
            for (var v of this.vehicles) {  
                options.push( { id: v.vehicleId, label: v.vehicleLabel, blockSequence: blockSequence.id } )
            }

           return options;
        },
        vehicleUpdated(item){
            this.changes.set(item.id, item);
            this.saveButtonDisabled = this.changes.size == 0;
            if(this.changes.size > 0) this.$emit('changed');
        },
        save(){
            this.loading = true;
            var list = Array.from(this.changes.values());

            this.$traveller_http.post('/traveller/restui/realtime/setVehicles', list  )
            .then( response => {
               
                this.ok = response.data.errorCode == 0;
                this.error = !this.ok;
                
                if(this.ok){
                    this.changes.clear();

                    //this.departureMap.clear();
                    this.newItem = null;
                   
                }
               
            })
            .catch( () => { this.error = true; } ) 
            .finally( () => { this.loading = false;  this.$emit('saved'); } ); 
            
        },

		filterItem(item) {
            if ( (this.filter.status == VehicleAssignedEnum.VEHICLE && !item.vehicleId) || (this.filter.status == VehicleAssignedEnum.NO_VEHICLE && item.vehicleId) )
                return false;

			if (this.filter.block != null && this.filter.block.length > 0 && (item.blockLabel == null || !item.blockLabel.toLowerCase().includes(this.filter.block.toLowerCase()))) 
				return false;
			if (this.filter.vehicle != null && this.filter.vehicle.length > 0 && (item.vehicleLabel == null || !item.vehicleLabel.toLowerCase().includes(this.filter.vehicle.toLowerCase()))) 
				return false;
            if(this.filter.time != null && String(this.filter.time).trim() !== '') {
                var timeParts = this.filter.time.split(':');
                var filterMinutes = parseInt(timeParts[0], 10) * 60 + (parseInt(timeParts[1], 10) || 0);
                var startMinutes = timeUtils.extractTimeMinutes(item.startTime);
                var endMinutes = timeUtils.extractTimeMinutes(item.endTime);
                if(startMinutes == null || endMinutes == null) return false;
                var crossesMidnight = endMinutes < startMinutes;
                var inRange = crossesMidnight 
                    ? (filterMinutes >= startMinutes || filterMinutes <= endMinutes)
                    : (filterMinutes >= startMinutes && filterMinutes <= endMinutes);
                if(!inRange)
                    return false;
            }
            return true;
		},
     
        formatTime(item) {
            var timeStr = "";
            if(item){
                var timeArray = item.split("T")[1].split(":");                       
                var departureTime = parseInt(timeArray[0], 10) * 60 + parseInt(timeArray[1], 10);
                var hours = Math.floor(departureTime / 60);
                var minutes = departureTime - hours * 60;
                
                timeStr = hours < 10 ? "0" + hours : hours;
                timeStr += ":" + (minutes < 10 ? "0" + minutes : minutes);
            }
            return timeStr; 
        },        
        getDate(item) {
            var timeArray = item.split("T")[0].split(":");                       
            var date = timeArray[0];
            return date; 
        }, 
        getDay(item) {
            for (var date of this.dateList) {
                if (item === date.id)
                    return date.date.split("-")[2] + "." + date.date.split("-")[1];
            }
            return null;
        }, 
        dateChanged(item) {
            for (var i = 0; i < this.dateList.length; i++) {
                if (this.dateList[i].id === item) {
                    return true;
                }
            }
            return false;
        },     
        getDepartures(bsId) {
            return this.departureMap.get(bsId);
        },
        listContains(item, list) {
            for (var i = 0; i < list.length; i++) {
                if (list[i] === item) {
                    return true;
                }
            }
            return false;
        },    
      
        showDepartures(bsId) {
            this.departuresVisible.add(bsId);
            this.updateView++;

            if (bsId) {
                this.loadingDepartures = bsId;
                this.$store.dispatch('realtime/getBSDepartures' , bsId)
                    .then( response => {
                        this.departureMap.set(bsId, response.data);
                        this.updateView++;
                })
                .finally( () => { this.loadingDepartures = null;  } ); 
            }        
        },
        hideDepartures(bs) {
            this.departuresVisible.delete(bs.id);
            this.splitApplied.delete(bs.id);
            this.updateView++;
        },
        split(originalBs, dep, index){
            this.splitApplied.set(originalBs.id, index);
            this.updateView++;
        },
        saveSplit(bs){
            this.loading = true;
            
            let index = this.splitApplied.get(bs.id);

            let departures = this.departureMap.get(bs.id);
            let dep = departures[index];
         
            let params = new URLSearchParams();
            params.append('id' , bs.id );
            params.append('from' , dep.id );

            this.$traveller_http.post('/traveller/restui/realtime/splitBlockSequence', params )
            .then( response => {
               
                this.ok = response.data.errorCode == 0;
                this.error = !this.ok;
                
                if(this.ok){
                    this.departuresVisible.delete(bs.id);
                    this.splitApplied.delete(bs.id);

                    var newBsId = response.data.message;

                    this.$store.dispatch('realtime/getDrivingCycles')
                    .finally(() => { 
                        this.loading = false; 
                        this.newItem = this.items.find( item => item.id == newBsId);
                        if(this.newItem)
                            this.showDepartures(this.newItem.id);
                       
                    })
                }
                               
            })
            .catch( () => { this.error = true; } ) 
            .finally( () => { this.loading = false; } ); 
        },
        onPageChange: function(page) {
        this.currentPage = page;
        }
    },
    mounted() {
         //if(!this.vehicleList || this.vehicleList.length === 0) 
         //    this.$store.dispatch('realtime/getVehicleList')
    }
}

</script>
<style lang="scss">


#bs-table {
    td {
        vertical-align: top !important;
    }

    td.status {
        width: 80px;
    }

    td.vehicle {
        width: 300px;
    }
    

    th.departures,
    td.departures {
        text-align: right;
        width: 600px;

    }

    td.departures > div {
        float: right;
    }


    td.departures .splitter {
        text-align: center;
        padding: 20px 0;
        /* font-size: 30px; */
    }

    .departure-table {
        width: 500px;

        tr {
            background-color: #fff !important;
        }

        td {
            border-bottom: 1px solid #ccc;
            padding: 8px;
            font-weight: normal;
            font-size: 12px;
       
            text-align: left;

            &.line{
                  text-align: right;
            }
        }
        


    }
}


#driving-cycle-table {
   
    .btn-success {
        /* margin-top: 10px; */

        svg {
            margin-right: 8px;
        }
    }

    .status {
        border-top: none;
    }

    .changed {
        .vs__dropdown-toggle {
            border-color: red;
        }
    }

    .one-line-text {
        white-space: nowrap;
    }
}

</style>

}